import { Gender } from '../models/filter-search';
import { GenderPerAgeChartData } from '../models/chart';

export enum GenderEnum {
  FEMALE = 0,
  MALE = 1,
  ONLINE_MEDIA = 2
}

export enum EngagementGaugeChartColors {
  COMMENT = 3,
  SHARE = 4,
  LIKE = 6,
  VIEW = 7,
  DISLIKE = 8,
  PLAYLIST = 9
}

export enum NumberUnit {
  THOUSAND = 1000,
  MILLION = 1000000,
  BILLION = 1000000000
}

export enum CampaignInfluencerStatus {
  NEW = 'New',
  ACTIVE = 'Active',
  DELETE = 'Ended',
  ARCHIVED = 'Archived',
  INVITED = 'Invited',
  ACCEPTED = 'Accepted'
}

export enum InfluencerTab {
  OVERVIEW = 1,
  INSIGHT = 2,
  DEMOGRAPHIC = 3,
  ACTIVITY = 4,
  CAMPAIGN = 5,
}

export enum InfluencerTabName {
  OVERVIEW = 'overview',
  INSIGHT = 'insight',
  DEMOGRAPHIC = 'demographics',
  ACTIVITY = 'activity',
  CAMPAIGN = 'campaign',
}

export enum ChannelStatus {
  AUTHORIZED = 1,
  UNAUTHORIZE = 2,
  REAUTHORIZE = 3,
  AUTHORIZE_FAILED = 4
}

export enum ChannelLimitation {
  MAX_CHANNEL_ADDED = 10
}

export const apiEndpoints = {
  login: '/login',
  authorizeUserByToken: '/authorizeUserByToken',
  authorizeUserByInviteToken: '/authorizeUserByInviteToken',
  me: '/me',
  definitions: '/definitions',
  forgotPassword: '/forgotPassword',
  authorizeByToken: '/authorizeByToken',
  acceptInvitation: '/acceptInvitation',
  precheckHashLink: '/precheckHashLink',
  register: '/register',
  platformSettings: '/user/:companyId/platform-settings',
  searchCompanies: '/admin/searchCompanies',
  getNumberOfCompanies: '/admin/getNumberOfCompanies',
  getAllCompanyType: '/admin/getAllCompanyType',

  getProjectOfAdvertiser: '/common/getAllProjectByAdvertiserID/',
  getAllAdvertiser: '/admin/GetAllAdvertiser',
  getGoverningAgencyByAgency: '/common/getGoverningAgencyByAgency/',
  getCPM: '/measure/getCPM',
  setCPM: '/measure/setCPM',
  getInfluencerInfo: '/influencer/getInfluencerInformation/:companyId',

  /**
   * API call to load group details
   */
  getInfluencerGroupDetails: '/influencerGroup/getInfluencerGroupDetails',
  updateInfluencerGroup: '/influencerGroup/updateInfluencerGroup',
  updateInfluencerGroupV2: '/influencerGroup/updateInfluencerGroupV2',
  getInfluencerGroupInfluencerKPI: '/influencerGroup/getInfluencerGroupInfluencerKPI',
  domain: '/influencer/find',
  getInfluencerListByGroupId: '/influencerGroup/:groupId/influencers',
  saveInfluencerManualAddedToInfluencerGroup: '/influencerGroup/saveInfluencerManualAddedToInfluencerGroup',
  getInfluencerGroupNameForAddInfluencerError: '/influencerGroup/getInfluencerGroupNameForAddInfluencerError',
  getManualAddedInfluencerList: '/influencerGroup/:groupId/getManualAddedInfluencers',
  moveInfluencersToAnotherGroup: '/influencerGroup/:groupId/moveInfluencersToAnotherGroup',
  getMonthlyVisitInfluencer: '/influencers/monthlyVisit',
  getPendingInfluencerList: '/group/:groupId/pending-influencers',
  addPendingInfluencerToGroup: '/group/:groupId/add-pending-influencers',
  getInfluencerGroupSourceTypes: '/influencerGroup/getInfluencerGroupSourceTypes',
  getInfluencerGroupFilterTypes: '/influencerGroup/getInfluencerGroupFilterTypes',
  /**
   * API call for Influencer Page
   */
  findInfluencer: '/influencer/find',
  searchInfluencer: '/influencer/search',
  // get details of one influencer
  getInfluencerById: '/influencer',
  // get details of influencer list
  loadInfluencerList: '/influencer/list',
  getChannelAudienceKPIs: '/influencer/getChannelAudienceKPIs',
  getPerformanceReportTimeLineChart: '/home/getPerformanceReportTimeLineChart',
  performanceGlobalKPIs: '/measure/getPerformanceGlobalKPIs',
  influencerBasicInformation: '/influencer/getInfluencerBasicInformation',
  getPlatform: '/admin/getPlatform',
  getExposurePlatforms: '/measure/getExposurePlatforms',
  getExposures: '/measure/getExposures',
  /**
   * API to load top exposure posts of one influencer
   */
  getTopExposures: '/influencer/:influencerId/topExposures',
  /**
   * API to load top exposure posts of multiple influencers
   */
  getTopExposureList: '/influencer/topExposureList',
  /**
   * API to load best performing posts of one influencer
   */
  getBestPerforming: '/influencer/:influencerId/bestPerforming',
  /**
   * API to load best performing posts of multiple influencers
   */
  getBestPerformingList: '/influencer/bestPerformingList',
  /**
  * API to load follower growth of an influencer
  */
  getFollowerGrowth: '/channel/:channelId/follower-growth',
  /**
   * API for Influencer Followers
   */
  getInfluencerFollowers: '/influencer/:influencerId/followers',
  /**
   * API for Channel Interaction Rate Development
   */
   getChannelInteractionRateDevelopment: '/channel/:channelId/engagement-rate-growth',
  /**
   * API get Performance Timeline
   * Old and new ES-based
   */
  measurePerformanceTimeline: '/measureReport/getPerformanceTimeline',
  measureGetMentionCount: '/measureReport/getMentionCount',
  measureGetPostCount: '/measureReport/getPostCount',
  measureGetPostIntereaction: '/measureReport/getPostInteraction',
  measureGetInfluencerCount: '/measureReport/getInfluencerCount',
  measureGetInfluencerOverview: '/measureReport/getInfluencerOverview',
  measureGetMentionTimeline: '/measureReport/getMentionTimeline',
  measureGetBestPerformingPosts: '/measureReport/getBestPerformingPosts',
  measureGetTopExposurePosts: '/measureReport/getTopExposurePosts',
  measureGetGlobalKpis: '/measureReport/getGlobalKpis',
  measureGetSegmentTopics: '/measureReport/getSegmentTopics',
  measureGetSegmentIndustries: '/measureReport/getSegmentIndustries',
  measureGetPlatformReach: '/measureReport/getPlatformReach',
  measureGetCountryReach: '/measureReport/getCountryReach',
  measureGetBenchmarkPerformance: '/measureReport/getBenchmarkPerformance',
  measureGetInsightChannelOpportunity: '/measureReport/getInsightChannelOpportunity',
  measureGetOonaReport: '/measureReport/getOonaReport',
  measureGetIntereactionPosts: '/measureReport/getInteractionPosts',
  measureGetIntereactionSummary: '/measureReport/getInteractionSummary',
  measureGetBestPerformingInfluencers: '/measureReport/getBestPerformingInfluencers',
  measureGetTopReturnOnInvestments: '/measureReport/getTopReturnOnInvestments',
  measureGetTotalReturnOnInvestments: '/measureReport/getTotalReturnOnInvestments',



  getDailyKpiTimeLineChart: '/influencer/:influencerId/dailyKpis',
  getDailyKpiOfMultipleInfluencer: '/influencer/dailyKpiList',
  getPerformanceGlobalKPIs: '/measure/getPerformanceGlobalKPIs',
  getInfluencerSegmentTopics: '/measure/getInfluencerSegmentTopics',
  getInfluencerTopMentions: '/influencer/:influencerId/topMentions',
  // load posts of one influencer
  getInfluencerPosts: '/influencer/:influencerId/posts',
  // load post of multiple influencers
  getPostsOfMultipleInfluencers: '/influencer/postList',
  getInstagramAudienceData: '/getInstagramAudienceData',
  getInfluencerTopPosts: '/influencer/:influencerId/topPosts',
  getCampaignInfluencerData: '/influencer/:campaignInfluencerId/campaignPost',
  getCampaignPostList: '/influencer/campaignPostList',
  /**
   * API call to get InfluencEye Data for demographic
   */
  loadDemographic: '/channel/:channelId/demographic',
  updateDemographic: '/channel/:channelId/update-demographic',

  /**
   * API call to create/update influencer Note
   */
  influencerNote: '/influencer/:influencerId/notes',
  deleteNote: '/notes/:noteId',

  /**
   * API to fetch Ig stories
   */
  influencerNewStories: '/influencer/:influencerId/stories',

  deleteInfluencerManualAdded: '/influencerGroup/deleteInfluencerManualAdded',
  removeInfluencers: '/influencerGroup/:groupId/removeInfluencers',
  approveInfluencers: '/influencerGroup/:groupId/approveInfluencers',

  /**
   * API call to get Post Details
   */
  getPostDetails: '/post/:urlHash',
  getPostDailyKpis: '/post/:urlHash/dailyKpis',
  getRelatedPosts: '/influencer/:influencerId/topExposures',
  getTopPosts: '/influencer/:influencerId/topPosts',
  getBlogpostOverviewData: '/blogPost/getBlogpostOverviewData',
  getChannelByRelativePath: '/blogpost/getChannelByRelativePath',
  getBlogPostKpi: '/blogPost/getBlogPostKpi',
  getCurrentPostMentions: '/blogPost/getCurrentPostMentions',
  getBlogpostOverviewLineChart: '/blogpost/getBlogpostOverviewLineChart',
  getBlogpostOverviewPieChart: '/blogpost/getBlogpostOverviewPieChart',
  getTop5PostsInSameInfluencer: '/blogpost/getTop5PostsInSameInfluencer',
  getSameInfluencerTopPosts: '/post/getSameInfluencerTopPosts',
  getTop5PostsInSameTopic: '/blogpost/getTop5PostsInSameTopic',

  /**
   * API call to load influencer groups
   */
  getInfluencerGroupList: '/influencerGroup/getInfluencerGroupList',
  getInfluencerGroupInfluencers: '/influencerGroup/:groupId/influencers',
  addNewInfluencerGroup: '/influencerGroup/addNewInfluencerGroup',
  deleteInfluencerGroup: '/influencerGroup/deleteInfluencerGroup',
  influencerGroups: '/influencerGroups',
  influencerGroupShortList: '/influencerGroups/shortList',
  groups: '/groups',
  bulkUploadInfluencer: '/influencerGroup/:influencerGroupId/bulk-upload',

  /**
   * API call to load campaigns
   */
  getSelectableCampaignTerms: '/campaign/getSelectableCampaignTerms',
  getCampaignsForCompany: '/campaign/getCampaignsForCompany',
  getCampaignShortListForCompany: '/campaigns/company/shortList',
  getInfluencerByCampaign: '/campaign/getAggregatedDataForCampaign',
  addInfluencerToCampaign: '/campaign/addInfluencersToOneCampaign',
  addNewCampaign: '/campaign/addNewCampaign',
  updateCampaign: '/campaign/updateCampaign',
  getAvailableCampaignsToAddPost: '/campaign/:companyId/getAvailableCampaignsToAddPost/:URL_HASH',
  addPostsToCampaign: '/campaign/:campaignId/addPostsToCampaign',
  getAllCampaignsForInfluencer: '/campaign/getAllCampaignsForInfluencer',
  getCampaignsOfInfluencerList: '/campaign/getCampaignsOfInfluencerList',
  getCampaignInfluencerKPIs: '/campaign/getCampaignInfluencerKPIs/',
  getCampaignInfluencerDetail: '/campaign/getCampaignInfluencerDetail/',
  getCampaignInfluencerDetailList: '/campaign/getCampaignInfluencerDetailList',
  getCampaignInfluencerPosts: '/campaign/getCampaignInfluencerPosts/',
  updateInfluencerCampaignStatus: '/campaign/updateInfluencerStatus',
  deleteInfluencerFromCampaign: '/campaign/deleteInfluencerFromCampaign/',
  deleteCampaignTerm: '/campaign/deleteTerm/',
  addCustomTerm: '/campaign/addCustomTerm',
  updateCampaignTerm: '/campaign/updateCustomTerm/',
  campaigns: '/campaigns/:companyId',
  searchCampaigns: '/searchCampaigns',
  campaignInfluencers: '/campaigns/:campaignId/influencers',
  campaignPostDailyKpis: '/campaign/:campaignInfluencerId/postDailyKpis',
  deletePost: '/campaign/:campaignId/deletePosts',
  getPostStatus: '/campaign/:campaignId/getPostStatus',
  acceptCampaignInvitation: '/campaign/acceptCampaign',
  declineCampaignInvitation: '/campaign/rejectCampaign',
  archiveCampaign: '/campaign/archiveCampaign',
  unarchiveCampaign: '/campaign/unarchiveCampaign',
  searchCampaignInfluencer: '/campaign/:campaignId/influencers',
  getCampaignInfluencerPostCount: '/campaign/:campaignId/postCount',
  /**
  * API Upload file
  */
  uploadFile: '/campaign/uploadFile',
  getUploadFile: '/campaign/getUploadedFile',
  deleteCampaign: '/campaign/deleteCampaign',
  getCampaignFiles: '/campaign/:CAMPAIGN_ID/getCampaignFiles',
  getCampaign: '/campaign',
  getCampaignInfluencers: '/campaign/:CAMPAIGN_ID/getCampaignInfluencers',
  getCampaignTerms: '/campaign/:CAMPAIGN_ID/getCampaignTerms',

  /**
   * API mentions
   */
  addNewProjectMention: '/mention/addNewProjectMention',
  addNewBlogPostMentions: '/blogPost/addNewBlogPostMentions',
  addNewMention: '/mention/addNewMention',
  checkNewMention: '/mention/checkNewMention',
  checkPostMentionExist: '/mention/existingMentionDiscover',
  setApprovedMention: '/mention/setApprovedMention',
  deleteMention: '/mention/deleteMention',
  searchMention: '/mention/searchMention',
  exists: '/mention/exists',

  /**
   * API discover
  */
  searchDiscoverInfluencer: '/discover/searchDiscoverInfluencer',
  saveSearchHistory: '/discover/saveSearchHistory',
  getSearchHistories: '/discover/getSearchHistories',
  getInfluencerGroupListSideBarMenu: '/influencerGroup/getInfluencerGroupListSideBarMenu',
  searchDiscoverPost: '/discover/searchDiscoverPost',
  discoverSearchPosts: '/discover/searchPosts',
  discoverSearchInfluencers: '/discover/searchInfluencers',

  /**
   * API for measure
   */
  getMeasureReportList: '/measure/getMeasureReportList',
  report: '/measure/report',
  getReturnOnInvestment: '/measure/getReturnOnInvestment',
  getPerformanceLocalAreas: '/measure/getPerformanceLocalAreas',
  getPerformanceMentionTimeLineChart: '/measure/getPerformanceMentionTimeLineChart',
  getExposureGlobalKPIs: '/measure/getExposureGlobalKPIs',
  getInsightBenchmarkPerformance: '/measure/getInsightBenchmarkPerformance',
  getInfluencerPostInteractions: '/measure/getInfluencerPostInteractions',
  getInsightChannelOpportunity: '/measure/getInsightChannelOpportunity',
  getSegmentTopics: '/measure/getSegmentTopics',
  getSections: '/measure/getSections',
  getSegmentIndutries: '/measure/getSegmentIndutries',
  getSegmentInfluencer: '/measure/getSegmentInfluencer',
  getBestPerformingInfluencers: '/measure/getBestPerformingInfluencers',
  newproject: '/project/newproject',
  updateProject: '/project/updateProject',
  deleteProject: '/project/:project_id',

  /**
   * API for pdf
   */
  generateInfluencerDetailPdf: '/generate/influencer/',
  generatePostOverviewPdf: '/generate/post',
  generateCampaignPdf: '/generate/campaign/',
  generateMeasurePdf: '/generate/measure',

  /**
   * API for project
   */
  addPostsManuallyIntoProject: '/project/:project_id/addPostsManuallyIntoProject',

  /**
   * API for post
   */
  getPostOverviewLineChart: '/post/getPostOverviewLineChart',

  /**
   * API for credit-based billing
   */
  creditBilling: '/billing/:companyId',
  updateBillingDetails: '/billing/updateBillingDetails',

  /**
   * API for Admin
   */
  updatePaymentMethod: '/admin/billing/createAccountOrder',
  getCreditAccountList: '/admin/billing/billingAccounts',
  saveCreditUsage: '/admin/billing/saveCreditUsage',
  getCreditUsageList: '/admin/billing/creditUsageList',
  updateNumberOfCredits: '/admin/billing/updateNumberOfCredits',
  createInvoice: '/admin/billing/createInvoice',
  getCreditInvoiceList: '/admin/billing/creditInvoiceList',
  updateCreditInvoice: '/admin/billing/updateInvoice',

  /**
   * API to add new influencer manually
   */
  getInfluencerChannels: '/admin/getInfluencerChannel/:influencerId',
  addInfluencer: '/user/addInfluencer',
  addChannel: '/channel/addChannel',
  addChannelByUser: '/channel/addChannelByUser',
  deleteChannel: '/channel/deleteChannel',
  updateChannel: '/channel/updateChannel',
  precheckChannel: '/channel/precheckChannel',
  addInfluencerByHandle: '/user/addInfluencerByHandle',
  /**
   * API for account levels
   */
  accountLevels: '/user/:companyId/account-levels',
  checkDemographic: '/user/:companyId/check-demographic/:channelId',
  /**
   * API sign-up, email verification
   */
  signUp: '/auth/sign-up',
  emailVerification: '/auth/verifyEmail',
  resetPasswordHash: '/resetPasswordHash',
  /**
   * Authorize FB/IG channel
   */
  getToken: '/instagram/getToken',
  updateUserProfile: '/admin/updateUserProfile',
  /**
   * Influencer management API
   */
  changepassword: '/changepassword',
  updateInfluencer: '/admin/updateInfluencer/:influencerId',
  loginStatus: '/instagram/getLoginStatus',
  /**
   * Influencer Communication API
   */
  loadConservations: '/company/:companyId/conversation',
  getConversationDetails: '/company/:companyId/conversation/:conversationId',
  addNewMessage: '/company/:companyId/conversation/:conversationId',
  retrieveConservationInfo: '/company/:companyId/conversation/influencer/:influencerId',
  markMessageAsSeen: '/company/:companyId/conversation/:conversationId/seen',
  fetchNewMessages: '/company/:companyId/conversation/:conversationId/fetchNewMessages',
  fetchInfluencerConversation: '/company/:companyId/conversation/influencer/:influencerId',

  exportCSV: '/generate/reportPosts',
  /**
   * Contact Permission
   */
  contactPermission: '/conversation/updatePermission',
  requestPermission: '/company/:companyId/influencer/:influencerId/requestPermission',
  loadContactPermission: '/conversation/getPermission',
  /**
   * Influencer Campaign
   */
  rejectCampaign: '/campaign/rejectCampaign',
  /**
   * Confirm Influencer
   */
  confirmInfluencer: '/influencer/:influencerId/confirm',
  requestNewInvitation: '/influencer/:influencerId/request',
  activeInfluencer: '/influencer/:influencerId/active',
  /**
   * Recently Visited Influencer
   */
  visitInfluencer: '/influencer/:influencerId/visit',
  /**
   * Get list of reviewer
   */
  getReviewerList: '/company/:companyId/reviewers',
  /**
   * User Billing
   */
  userBilling: '/company/:companyId/billing',
  /**
   * User monthly usage
   */
  userMonthlyUsage: '/company/:companyId/monthlyUsage',
    /**
   * API for account settings
   */
  updateProfile: '/user/updateprofile',
  /**
   * API for Sign-up page
   */
  getSignUpPageData: '/company/:companyId/sign-up-page',
  /**
   * API for Channel Followers
   */
  channelFollowers: '/influencer/:influencerId/followers',
  /**
   * API for User Notification Settings
   */
  notificationSetting: '/user/notification-settings',
  /**
   * API for Chameleon create sample data
   */
  sampleSetups: '/user/sample-setups',
  setupSampleData: '/user/:companyId/setup-sample-data',
  /**
   * API to search group
   */
  searchGroups: '/searchGroups',
  /**
   * API for campaign notification
   */
  lastViewedTime: '/user/notification/:type/last-seen/:company_id',
  getNewEventsFromTimestamp: '/user/notification/:type/new-events/:company_id/:timestamp',
  /**
   * API for pending Influencer
   */
  getPendingInfluencers: '/admin/pending-influencers',
  getPendingInfluencerById: '/admin/pending-influencer/:influencer_id',
  getLanguageByCountry: '/admin/getCountryLanguage',
  getDismissReasons: '/admin/getDismissReason',
  /**
   * API for User Email Settings
   */
  emailSettings: '/notification-settings',
  /**
   * User Billing
   */
  checkoutSubscription: '/company/:companyId/checkout-subscription',
  portalSession: '/company/:companyId/portal-session',
  influencerUsage: '/company/:companyId/influencerUsage'
};

export const systemValues = {
  defaultUserAvatarPicture: 'assets/images/default-user-avatar.jpg',
  noImagePicture: 'assets/images/No_Image.png',
  platformIconPath: 'assets/images/platform',
  defaultPeriod: 30,
};

export class CommonConstant {
  static PAGINATION_INFLUENCER_SIZE = 100;
  static START_PAGE_INDEX = 1;
  static ZERO = 0;
  static K_VALUE = 1000;
  static M_VALUE = 1000000;
  static THOUSAND_SYMBOL = 'K';
  static MILLION_SYMBOL = 'M';
  static BILLION_SYMBOL = 'B';
  static ENTER_CODE = 'Enter';
  static DAYS_OF_WEEK = 7;
  static REACH_EXPOSURE_INDEX = 0;
  static ENGAGEMENT_EXPOSURE_INDEX = 1;
  static IMPACT_EXPOSURE_INDEX = 2;
  static AU_LOCALE = 'en-AU';
  static US_LOCALE = 'en-US';
  static LATEST = 'latest';
  static LIMIT_20 = 20;
  static LIMIT_INFLUENCER_POST_OVERVIEW = 12;
  static PERIOD_7_DAYS = 7;
  static PERIOD_30_DAYS = 30;
  static PREFERRED_INFLUENCER = 1;
  static STARTING_INDEX = 1;
  static DEFAULT_INFINITE_SCROLL_DISTANCE = 1;
  static DEFAULT_INFINITE_SCROLL_DISTANCE_UP = 2;
  static DEFAULT_INFINITE_SCROLL_THROTTLE = 300;
  static DEFAULT_INFINITE_SCROLL_THROTTLE_100 = 100;
  static DEFAULT_CHAT_MESSAGES_SIZE = 50;
  static PDF_EXPORT_NOTIFICATION_SHOWING_TIME = 8;
  static SHOW_PLACEHOLDER = 'show';
  static HIDE_PLACEHOLDER = 'hide';
  static CHART_OPTIONS = {
    LEGEND_SYMBOL_TYPE: {
      CIRCLE: 'circle',
      SQUARE: 'square'
    },
    LEGEND_ALIGN: {
      LEFT: 'left',
      RIGHT: 'right',
      CENTER: 'center',
    },
    LEGEND_VERTICAL_ALIGN: {
      TOP: 'top',
      BOTTOM: 'bottom',
      MIDDLE: 'middle',
    },
    LEGEND_LAYOUT: {
      VERTICAL: 'vertical',
      HORIZONTAL: 'horizontal'
    }
  };
  static DEFAULT_PLATFORM_REACH_LINE_COLOR: '#FF6C9D';
  static REACH_NAME = 'Reach';
  static REACHE_LINE_COLOR = '#FF6C9D';
  static IMPRESSION_NAME = 'Impression';
  static IMPRESSIONS_NAME = 'Impressions';
  static IMPRESSION_LINE_COLOR = '#55E9A9';
  static ENGAGEMENT_NAME = 'Engagement';
  static MENTIONS_NAME = 'Mentions';
  static ENGAGEMENT_LINE_COLOR = '#00D6EF';
  static IMPACT_NAME = 'Impact';
  static LOGIN_PLACEHOLDER = 'loginComponentHolder';
  static INFLUENCER_BASIC_INFORMATION_HOLDER = 'influencerBasicInformation';
  static INFLUENCER_GROUP_LIST_HOLDER = 'influencerGroupListHolder';
  static POST_LIST_HOLDER = 'postListHolder';
  static TOP_MENTION_HOLDER = 'topMentionHolder';
  static CHART_POPULAR_TOPIC_HOLDER = 'chartPopularTopicHolder';
  static TOPIC_AND_ENGAGEMENT_CHART_HOLDER = 'topicAndEngagementChartHolder';
  static GROUP_SETTING_HOLDER = 'groupSettingHolder';
  static INFLUENCER_CAMPAIGN_DETAILS_HOLDER = 'influencerCampaignDetailsHolder';
  static CHANNEL_AUTHORIZATION_HOLDER = 'channelAuthorizationHolder';
  static ADD_ACTION = 'add';
  static PERCENT_DATA_TYPE = 'percent';
  static NUMBER_DATA_TYPE = 'number';
  static NA_VALUE = 'NA';
  static BENCHMARK_IMPACT = 'impact';
  static CURRENCY_COL = 'Currency';
  static ROI_COL = 'roi';
  static INFLUENCERS_COL = 'influencers';
  static POSTS_COL = 'posts';
  static IMPRESSIONS_COL = 'impressions';
  static REACH_COL = 'reach';
  static EUROPE_CURRENCY = 'EUR';
  static US_CURRENCY = 'USD';
  static DANISH_KRONE_CURRENCY = 'DKK';
  static NORWAY_CURRENCY = 'NOK';
  static SWEDISH_CURRENCY = 'SEK';
  static POUND_CURRENCY_CODE = 'GBP';
  static POUND_CURRENCY = '£';
  static INTERNATIONAL_ID = 250;
  static INTERNATIONAL_LANGUAGE = 45;
  static DISCOVER_DEBOUNCE_TIME = 700;
  static DISCOVER_INFLUENCER_LIST_HOLDER = 'inDiscoverInfluencerHolder';
  static DISCOVER_POST_LIST_HOLDER = 'inDiscoverPostHolder';
  static TRANSITION_TIME = 300;
  static PREVIEW_ITEM_HEIGHT = 148;
  static COLLAPSED_BOTTOMBAR_HEIGHT = 100;
  static DEFAULT_BOTTOMBAR_MAX_HEIGHT = 600;
  static LOWER_CASE_SHORT_LETTER_LENGTH = 10;
  static LOWER_CASE_NORMAL_LETTER_LENGTH = 14;
  static LOWER_CASE_LONG_LETTER_LENGTH = 20;
  static UPPER_CASE_SHORT_LETTER_LENGTH = 16;
  static UPPER_CASE_NORMAL_LETTER_LENGTH = 18;
  static UPPER_CASE_LONG_LETTER_LENGTH = 24;
  static MAX_LENGTH_REPORT_NAME_FIELD = 650;
  static CAMPAIGN_LIST_HOLDER = 'campaignListHolder';
  static CREATE_NEW_GROUP_HOLDER = 'createNewGroupPlaceholder';
  static DEFAULT_MENU_VISIBLE = 1;
  static GROUP_DETAILS_PLACEHOLDER = 'groupDetailsInfluencerListHolder';
  static ADD_NEW_INFLUENCER_PLACEHOLDER = 'addNewInfluencerPlaceholder';
  static DEMOGRAPHIC_PLACEHOLDER = 'demographicPlaceholder';
  static MAX_UPLOADED_FILE_SIZE = 20;
  static MAX_PROFILE_PICTURE_SIZE = 2048;

  static MAX_ROI_ITEM_IN_PDF_PAGE = 14;
  static MAX_OONA_ITEM_IN_PDF_PAGE = 8;
  static MAX_INTERACTION_ITEM_IN_PDF_PAGE = 15;
  static BASIC_CAMPAIGN_ACTION = 'Basic brief';
  static DELETE_INFLUENCER_FROM_GROUP = 'Delete influencer from group';
  static ADD_INFLUENCER_TO_GROUP = 'Add influencer to group';
  static DEFAULT_CONVERSATION_OFFSET = 0;
  static NEW_AUTO_GROUP_SOURCE_KEY = 'new_auto_group_sources';
  static NEW_AUTO_GROUP_FILTER_KEY = 'new_auto_group_filters';
  static LIST_PROJECT_KEY = 'list_all_projects';
  static BRANDED_SIGNUP_CONFIG_KEY = 'branded_signup_config';
  static NOTIFICATION_ACTIVITY_SETTING = 'activity';
  static NOTIFICATION_PENDING_ACTION_SETTING = 'pending_actions';
  static NOTIFICATION_UPDATES_SETTING = 'updates';
  static NOTIFICATION_PROMOTION_EMAIL_SETTING = 'promotional_emails';
  static LIST_ADVERTISER_BELONG_TO_USER = 'all_advertisers';
  static YOUTUBE_CHANNEL = 'Channel';

  static GENDERS: Gender[] = [
    { name: 'Female', id: GenderEnum.FEMALE },
    { name: 'Male', id: GenderEnum.MALE },
    { name: 'Online Media', id: GenderEnum.ONLINE_MEDIA }
  ];
  static KB_UNIT = 1024;
  static MAX_LOG_LENGTH = 20000;

  static CAMPAIGN_INFLUENCER_STATUS = {
    DECLINED: {
      name: 'DECLINED',
      value: 1
    },
    INVITED: {
      name: 'INVITED',
      value: 2
    },
    ACCEPTED: {
      name: 'ACCEPTED',
      value: 3
    },
    ACTIVE: {
      name: 'ACTIVE',
      value: 3
    },
    PUBLISHED: {
      name: 'PUBLISHED',
      value: 4
    },
    INTERESTED: {
      name: 'INTERESTED',
      value: 5
    }
  };

  static CURRENCIES = [
    { name: 'Euro (€)', id: 0 },
    { name: 'US Dollar ($)', id: 1 },
    { name: 'Danish Krone (DKK)', id: 2 },
    { name: 'Norwegian Kroner (NOK)', id: 3 },
    { name: 'Swedish Krona (SEK)', id: 4 },
    { name: 'Pound (£)', id: 5 }
  ];

  static CPM_CALCULATION_METHODS = [
    { name: 'Engagement Fueled CPM', id: 0 }
  ];

  static MAX_ITEM_PER_PAGE_REPORT = 8;
  static MAX_ITEM_ALLOWED_BY_PDF = 48;
  static GREEN_COLOR_INDEX = 0;
  static RED_COLOR_INDEX = 8;
  static BLUE_COLOR_INDEX = 1;
  static INTERNATION_COUNTRY_CODE = 'inter';

  static PAYMENT_METHOD = [
    { id: 'contract', name: 'Subscription' },
    { id: 'pay-as-you-go', name: 'Pay-as-you-go' }
  ];

  static COMPANY_TYPE = {
    ALL_ACCOUNT_TYPE: {
      id: 0,
      name: 'All Account Type'
    },
    ADVERTISER: {
      id: 1,
      name: 'Advertiser'
    },
    SOCIAL_AGENCY: {
      id: 2,
      name: 'Social Agency'
    },
    MEDIA_AGENCY: {
      id: 3,
      name: 'Media Agency'
    },
    PR_AGENCY: {
      id: 4,
      name: 'PR Agency'
    },
    NETWORK: {
      id: 5,
      name: 'Network'
    },
    INFLUENCER: {
      id: 6,
      name: 'Influencer'
    },
  };

  static ACCOUNT_LEVEL = [
    { id: 1, name: 'Gold' },
    { id: 2, name: 'Silver' },
    { id: 3, name: 'Bronze' }
  ];
  static MAX_REACH_FOLLOWER = 1000000;
  static MAX_REACH_ENGAGEMENT = 1000000;
  static NEW_MAX_IMPACT = 300;
  static OLD_MAX_IMPACT = 100;
  static MAX_INFLUENCERS_INTO_GROUP = 1000;
  static MAX_DAYS_MEASURE = 60;
  static DISCOVER_SEARCH_CRITERIA_KEY = 'DISCOVER_SEARCH_CRITERIA';
  static HAVE_TRIGGERED_DISCOVER_INFLUENCER = 'HAVE_TRIGGERED_DISCOVER_INFLUENCER';
  static HAVE_TRIGGERED_DISCOVER_POST = 'HAVE_TRIGGERED_DISCOVER_POST';
  static DISCOVER_TAB = 'DISCOVER_TAB';
  static DISCOVER_SCROLL_TOP = 'DISCOVER_SCROLL_TOP';
  static INTERNAL_SERVER_ERROR = 500;
  static INFLUENCER_HANDLE_EXISTED = 'channel_belong_signed_up_user';
  static NO_BUSSINES_USER_ERROR = 'no_business_user';
  static FACEBOOK_ERROR = 'facebook_error';
  static MISSING_TOKEN = 'missing_token';
  static INVALID_TOKEN = 'invalid_token';
  static MISSING_CHANNEL = 'missing_channel';
  static INVALID_CHANNEL = 'invalid_channel';
  static NOT_OWN_CHANNEL = 'not_own_channel';
  static CHANNEL_OWNED_BY_OTHERS = 'channel_owned_by_others';
  static TOO_MANY_POSTS_TO_MERGE_OR_STEAL = 'too_many_posts_to_merge_or_steal';
  static UNABLE_TO_CHECK_POSTS_ON_ES = 'unable_to_check_posts_on_es';
  static BLOG_CHANNEL_AUTH_FAIL = 'blog_channel_auth_fail';
  static CHANNEL_AUTHORIZATION_DATA = 'channel_authorization_data';
  static CHANNEL_AUTHORIZATION_DATE = 'authorized_channel';
  static INFLUENCER_LIST_PLACEHOLDER = 'InfluencerListHolder';
  static DEFAULT_USER_AVATAR = 'assets/images/sidebar/default-user-avatar.png';
  static EUROPE_CURRENCY_SYMBOL = '€';
  static MONTHLY_PRICING_PLACEHOLDER = '€ 199';
  static CURRENCY_SIGN = {
    EURO: '€',
    USD: '$',
    DANISH_KRONE: 'DKK',
    NORWEGIAN_KRONER: 'NOK',
    SWEDISH_KRONA: 'SEK',
    POUND: '£'
  };
  static INTERNATIONAL_COUNTRY_DATA = {
    name: 'International',
    code: null
  };
  static GENDER_PER_AGE_PERCENTAGE = {
    RANGE_50: [50, 40, 30, 20, 10, 0],
    RANGE_75: [75, 60, 45, 30, 15, 0],
    RANGE_100: [100, 80, 60, 40, 20, 0],
    RANGE_125: [125, 100, 75, 50, 25, 0]
  };
  static GENDER_PER_AGE_PERCENTAGE_DEFAULT_VALUE = 40;
  static GENDER_PER_AGE_CHART_FULL_HEIGHT = 100;
  static GENDER_PER_AGE_CHART_LAST_RANGE_VALUE = '55+';
  static GENDER_PER_AGE_HIGHEST_RANGE_VALUE = '55';
  static GENDER_PER_AGE_DEFAULT_VALUE: Array<GenderPerAgeChartData> = [
    {range: '13-17', f: 0, m: 0},
    {range: '18-24', f: 0, m: 0},
    {range: '25-34', f: 0, m: 0},
    {range: '35-44', f: 0, m: 0},
    {range: '45-54', f: 0, m: 0},
    {range: '55-64', f: 0, m: 0}
  ];
  static AGE_RANGE_45_64 = '45-64';
  static REPLACED_45_64_AGE_RANGE = '45-54';
  static BRAND_AFFINITY_TOP_ITEM = 20;
  static PIE_CHART_TOP_ITEM = 10;
  static DEMOGRAPHIC_GENDER_CHART_MAX_WIDTH = 225;
  static DEMOGRAPHIC_BAR_CHART_PROGRESS_HEIGHT = 10;
  static DEMOGRAPHIC_BAR_CHART_BORDER_RADIUS = 4;
  static DEFAULT_NOTE_BOX_STYLE_HEIGHT = '53px';
  static DEFAULT_NOTE_HEIGHT = 53;
  static MAX_AUTO_GROUP_SOURCE = 3;
  static AUTO_GROUP_PROJECT_TYPE = 'project';
  static NEW_AUTO_GROUP_TYPE = 6;
  static ALL_MODULES_ID = 2;
  static NEW_CREATED_GROUP_ID = 1;
  static SORT_BY_REACH = 'reach';
  static DEFAULT_ASCENDING_ORDER_SORT_BY = 0;
  static MIN_CHARATER_TO_TRIGGER_SEARCH = 3;
  static LAST_VIEWED_CAMPAIGN_TIME_KEY_PREFIX = 'lvc';
  static MAX_RETRY_ON_ERROR_LAST_VIEW_TIME = 2;
}

export const platformIconPath = {
  blogs: { path: 'assets/images/platform/Blogger.svg', color: '#54D89F', name: 'Blogs', id: 1, host: 'www.blogger.com', prefix: 'http://' },
  instagram: { path: 'assets/images/platform/Instagram.svg', color: '#EC506E', name: 'Instagram', id: 2, host: 'www.instagram.com', prefix: 'https://www.instagram.com/' },
  pinterest: { path: 'assets/images/platform/Pinterest.svg', color: '#55ACEE', name: 'Pinterest', id: 3, host: 'www.pinterest.com', prefix: 'https://www.pinterest.com/' },
  snapchat: { path: 'assets/images/platform/Snapchat.svg', color: CommonConstant.DEFAULT_PLATFORM_REACH_LINE_COLOR, name: 'Snapchat', id: 4, host: 'www.snap.com', prefix: '@' },
  twitter: { path: 'assets/images/platform/Twitter.svg', color: CommonConstant.DEFAULT_PLATFORM_REACH_LINE_COLOR, name: 'Twitter', id: 5, host: 'twitter.com', prefix: 'https://twitter.com/' },
  youtube: { path: 'assets/images/platform/Youtube.svg', color: '#315A87', name: 'Youtube', id: 6, host: 'www.youtube.com', prefix: 'https://www.youtube.com/channel/' },
  facebook: { path: 'assets/images/platform/Facebook.svg', color: CommonConstant.DEFAULT_PLATFORM_REACH_LINE_COLOR, name: 'Facebook', id: 7, host: 'www.facebook.com', prefix: 'https://www.facebook.com/' },
  tiktok: { path: 'assets/images/platform/TikTok.svg', color: CommonConstant.DEFAULT_PLATFORM_REACH_LINE_COLOR, name: 'TikTok', id: 8, host: 'www.tiktok.com', prefix: 'https://www.tiktok.com/' },
};

export const marketDrillDownColorIndex = ['#54D89F', '#EC506E', '#55ACEE', '#315A87'];
export const longLetters = ['w', 'm', 'o'];
export const shortLetters = ['t', 'l', 'f', 'i', 'j', ' ', '-'];

export const measureModuleIconPath = {
  oonaReport: {
    id: 19,
    path: 'assets/images/custom-report/post-benchmark-icon.svg',
    inactivePath: 'assets/images/custom-report/post-benchmark-inactive-icon.svg',
  },
  interactionReport: {
    id: 18,
    path: 'assets/images/custom-report/interactions-report-icon.svg',
    inactivePath: 'assets/images/custom-report/interactions-report-inactive-icon.svg',
  },
  returnOnInvestmentsROI: {
    id: 17,
    path: 'assets/images/custom-report/return-on-investment-icon.svg',
    inactivePath: 'assets/images/custom-report/return-on-investment-inactive-icon.svg',
  },
  bestPerformingInfluencers: {
    id: 16,
    path: 'assets/images/custom-report/best-performing-influencers-icon.svg',
    inactivePath: 'assets/images/custom-report/best-performing-influencers-inactive-icon.svg',
  },
  averageBenchmarkPerformace: {
    id: 12,
    path: 'assets/images/custom-report/average-benchmark-performance-icon.svg',
    inactivePath: 'assets/images/custom-report/average-benchmark-performance-inactive-icon.svg',
  },
  channelOpportunities: {
    id: 11,
    path: 'assets/images/custom-report/channel-opportunities-icon.svg',
    inactivePath: 'assets/images/custom-report/channel-opportunities-inactive-icon.svg',
  },
  industriesDrilldown: {
    id: 10,
    path: 'assets/images/custom-report/industries-drill-down-icon.svg',
    inactivePath: 'assets/images/custom-report/industries-drill-down-inactive-icon.svg',
  },
  topicsDrilldown: {
    id: 9,
    path: 'assets/images/custom-report/topics-drill-down-icon.svg',
    inactivePath: 'assets/images/custom-report/topics-drill-down-inactive-icon.svg',
  },
  influencersOverview: {
    id: 8,
    path: 'assets/images/custom-report/influencers-overview-icon.svg',
    inactivePath: 'assets/images/custom-report/influencers-overview-inactive-icon.svg',
  },
  bestPerformanceExposures: {
    id: 7,
    path: 'assets/images/custom-report/best-performance-exposures-icon.svg',
    inactivePath: 'assets/images/custom-report/best-performance-exposures-inactive-icon.svg',
  },
  platformDrilldown: {
    id: 6,
    path: 'assets/images/custom-report/platform-drill-down-icon.svg',
    inactivePath: 'assets/images/custom-report/platform-drill-down-inactive-icon.svg',
  },
  exposureKpis: {
    id: 5,
    path: 'assets/images/custom-report/exposure-kpis-icon.svg',
    inactivePath: 'assets/images/custom-report/exposure-kpis-inactive-icon.svg',
  },
  marketDrillDown: {
    id: 3,
    path: 'assets/images/custom-report/market-drill-down-icon.svg',
    inactivePath: 'assets/images/custom-report/market-drill-down-inactive-icon.svg',
  },
  mentionTimeline: {
    id: 4,
    path: 'assets/images/custom-report/mention-timeline-icon.svg',
    inactivePath: 'assets/images/custom-report/mention-timeline-inactive-icon.svg'
  },
  performanceKpis: {
    id: 2,
    path: 'assets/images/custom-report/performance-kpis-icon.svg',
    inactivePath: 'assets/images/custom-report/performance-kpis-inactive-icon.svg'
  },
  performanceTimeline: {
    id: 1,
    path: 'assets/images/custom-report/performance-timeline-icon.svg',
    inactivePath: 'assets/images/custom-report/performance-timeline-inactive-icon.svg'
  },
};

export const platformIconPathById = {
  1: platformIconPath.blogs,
  2: platformIconPath.instagram,
  3: platformIconPath.pinterest,
  4: platformIconPath.snapchat,
  5: platformIconPath.twitter,
  6: platformIconPath.youtube,
  7: platformIconPath.facebook,
  8: platformIconPath.tiktok,
};

export const listOrderedPlatforms = [
  platformIconPath.blogs,
  platformIconPath.instagram,
  platformIconPath.pinterest,
  platformIconPath.snapchat,
  platformIconPath.twitter,
  platformIconPath.youtube,
  platformIconPath.facebook,
  platformIconPath.tiktok
];

export const pieChartColors = [
  '#5ad7a0', '#59adeb', '#ea5270', '#f3a536', '#335b85'
];

export const numberFormat = {
  thousandSuffixes: ['K', 'M', 'G', 'T', 'P', 'E'],
};

export const chartConfig = {
  type: {
    column: 'column',
    pie: 'pie',
    bar: 'bar',
  },
  seriesColors: ['#2f7959', '#59adeb', '#ea5270', '#f3a536', '#335b85', '#00769A', '#A4C6D3', '#54D89F', '#EC506E', '#68B3CB'],
  title: {
    align: 'left',
    padding: 13,
    paddingTop: 18,
    paddingLeft: 12
  },
  font: {
    light: 'QuicksandLight',
    regular: 'Quicksand',
    semiBold: 'QuicksandSemibold'
  },
  xAxis: {
    type: 'category',
    labelColor: '#B5BECB'
  },
  yAxis: {
    lineColor: 'transparent',
    labelColor: '#B5BECB'
  },
  legend: {
    labelMaxCharacterSize: 14
  },
  pieChart: {
    size: '171px',
    mobileSize: '130px',
    innerSize: '75%'
  },
  transparentBackground: 'rgba(255, 255, 255, 0.0)',
  defaultSpacingTop: 10,
  defaultSpacingLeft: 10,
  defaultSpacingRight: 10,
  defaultSpacingBottom: 15,
  defaultDataLabelFontSize: '1.1125rem',
  defaultTitleStyling: {
    fontSize: '0.99rem',
    color: '#95A0B1',
    fontFamily: 'QuicksandSemibold'
  },
  mobileTitleStyling: {
    fontSize: '11px',
    fontFamily: 'Quicksand, Arial, Helvetica, sans-serif',
    whiteSpace: 'nowrap',
  },
  defaultLineChartPosition: {
    x: 1,
    y: -27,
    itemDistance: 7
  },
  defaultLineChartSpacingBottom: 23,
  defaultColor: '#95A0B1',
  lightColor: '#b5becb',
  tooltipBackgroundColor: '#445166',
  defaultFontSize: 11,
  columnChart: {
    marginTop: 68,
    marginBottom: 37.5,
    marginRight: 20,
    marginLeft: 20,
    borderRadiusTop: 9,
    labelsPadding: 10,
    pointWidth: 18
  },
  gaugeChart: {
    radius: '112%',
    innerRadius: '85%',
    spacingTop: 25,
    spacingBottom: 15,
    titlePositionTop: -10,
    titlePositionBottom: 15,
    paneInnerRadius: '85%',
    pannelBackgroundColor: 'rgba(219, 226, 237, 0.35)',
    yAxisMin: 0,
    yAxisMax: 100
  },
  lineChart: {
    letterSpacing: '1px',
    tooltipBorderRadius: 6,
    tooltipBorderWidth: 0,
    tooltipColor: '#FFFFFF',
    tooltipPadding: '6',
    legendFontWeight: '600',
    legendFontSize: '0.7125rem',
    legendMobileFontSize: '0.25rem',
    legendLeft: '5px',
    legendMargin: 12,
    lineWidth: 3,
    hoverLineWidth: 5
  },
  industryDrillDownChart: {
    chartHeight: 248,
    chartSize: '100%',
    titleStyling: {
      textTransform: 'uppercase',
      fontSize: '1rem'
    },
    chartLegend: {
      x: 0,
      y: 31,
      useHTML: true
    }
  },
  fallbackViewColor: '#f7f7f8',
  defaultMarginLeft: 0,
  defaultLegendStyle: {
    defaultSize: 150,
    mobileSize: 140,
    marginTop: 9
  },
  unselectedColors: [
    'rgba(113,125,141,0.50)',
    'rgba(113,125,141,0.30)',
    'rgba(113,125,141,0.10)'
  ]
};

export const kpiAttributes = {
  reach: 'reach',
  impact: 'impact',
  engagement: 'engagement',
};

export const iframePageState = {
  admin: 'home.adminContent',
  profile: 'home.profile',
  changePassword: 'home.profileChangePassword',
  billing: 'home.profileBilling',
  influencerCampaign: 'home.campaignInfluencersManagePage',
};

export const mentionType = {
  keyword: 1,
  url: 2,
  hashtag: 3,
};

export const languageId = {
  global: 0,
};

export const mentionStatus = {
  addNew: 'addNew',
};

export const discoverFilterSearchConst = {
  limit: 50,
  period: 60,
  offset: 0,
  orderBy: 'latest'
};

export const defaultPlatformSettings = {
  id: 0,
  platformName: 'Influencer Impact',
  sendOutEmailName: undefined,
  sendOutEmailDomain: undefined,
  logo: 0,
  chartColors: ['#5ad7a0', '#59adeb', '#ea5270', '#f3a536', '#335b85', '#445166', '#55ACEE', '#54D89F', '#EC506E', '#717D8D'],
  platformBgColor: '#eef2f5',
  bottombarBgColor: '#4E5B61',
  bottombarButtonColors: ['#F3953F', '#58a4c0', '#58a4c0', '#58a4c0'],
  emailBgColor: '#eef2f5',
  emailButtonColors: ['#fb6d9d', '#1976d2'],
  logoContent: 'assets/images/influencer-impact-white-bg-logo.svg',
  leftSidebarLogoContent: 'assets/images/influencer-impact-white-bg-square-logo.svg',
  influencerAppLogoContent: 'assets/images/achoo.svg'
};

export enum FacebookAuthPreviousState {
  AUTHENTICATED = 'authenticated',
  CONFIRMED = 'confirmed',
  ON_CAMPAIGN_INVITATION = 'campaign_invitation',
  ON_CONTACT_PERMISSION = 'contact_permission',
}

export enum FacebookAuthSource {
  ORGANIC_LOGIN = 'organic_login',
  INFLUENCER_SETTING = 'influencer_setting',
  CAMPAIGN_INVITATION = 'campaign_invitation',
  CONTACT_PERMISSION = 'contact_permission',
}

export enum AccountType {
  BRAND = 'Brand',
  AGENCY = 'Agency'
}

export enum PremiumTrialStep {
  ACCOUNTTYPE = 1,
  AGENCYTYPE = 2,
  ACCOUNTGOAL = 3,
  ACCOUNTDETAILS = 4
}

export enum AgencyOptionType {
  TYPEOFAGENCY = 'agency-type',
  SIZEOFAGENCY = 'agency-size'
}

export enum KpiStatus {
  ASC = 'asc',
  DESC = 'desc'
}

export const agencyList = {
  agencyTypeList: [
    {id: 'Media', name: 'Media', optionType: 'agency-type'},
    {id: 'PR', name: 'PR', optionType: 'agency-type'},
    {id: 'Creative', name: 'Creative', optionType: 'agency-type'},
    {id: 'Digital Marketing', name: 'Digital Marketing', optionType: 'agency-type'},
    {id: 'Influencer Marketing', name: 'Influencer Marketing', optionType: 'agency-type'}
  ],
  numberOfCorworkers: [
    {id: '2 - 5', name: '2 - 5', optionType: 'agency-size'},
    {id: '6 - 20', name: '6 - 20', optionType: 'agency-size'},
    {id: '21 - 50', name: '21 - 50', optionType: 'agency-size'},
    {id: '51 - 200', name: '51 - 200', optionType: 'agency-size'},
    {id: '201+', name: '201+', optionType: 'agency-size'}
  ]
};

export const RecentlyVisitedInfluencerGroup = {
  name: 'Recently Visited Influencers',
  description: 'List of the influencer profiles you visited the last month'
};

export const performingInfluencerSortList = [
    {id: 'engagement', name: 'Sort by Engagement'},
    {id: 'reach', name: 'Sort by Reach'},
];

export enum BestPerformingInfluencerSortBy {
  ENGAGEMENT = 'engagement',
  REACH = 'reach'
}

export enum GenderPerAgeChartYMaxRange {
  MAX_40 = 40,
  MAX_65 = 65,
  MAX_90 = 90
}

export const pieChartConfig = {
  mobileChartMarginLeft: 20,
  chartMarginLeft: 45,
  defaultChartSpacingLeft: 10,
  defaultChartSpacingRight: 0,
  defaultChartSpacingTop: 10,
  mobileLegendX: 15,
  defaultSmallChartLegendX: -20,
  defaultLegendX: -4,
  defaultLegendSymbolSize: 10,
  defaultLegendSymbolRadius: 3,
  defaultLegendPadding: 0,
  defaultTitleX: 5,
  defaultTitleY: 15,
  mobilePieCenter: [45, 60],
  smallPieCenter: [70, 70],
  defaultPieCenter: [103, 85],
  smallPieSize: 460,
  demographicLegendX: -30,
  defaultNavigationArrowSize: 12,
  defaultNavigationActiveColor: '#003399',
  defaultNavigationInactiveColor: '#cccccc',
  pdfView: {
    pieChartHeight: 225,
    pieChartCenter: [25, 70],
    pieChartSize: 151,
    pieChartInnerSize: '75%',
    pieChartTitleStyling: {
      fontSize: '0.82rem'
    },
    pieChartLegend: {
      x: 43,
      y: 26,
      itemMarginBottom: 3,
      useHTML: true,
      enabledNavigation: true
    }
  },
  newTitleStyling: {
    fontSize: '16px',
    color: '#445166',
    fontFamily: 'QuicksandSemibold, Arial, Helvetica, sans-serif'
  }
};

export const OnboardingTourConstant = {
  filterIndex0: 0,
  filterIndex1: 1,
  filterIndex2: 2,
  filterIndex3: 3,
  genderList: {
    female: 'female',
    male: 'male'
  },
  ageList: [
    {id: 0, range: 'from13to17'},
    {id: 1, range: 'from18to24'},
    {id: 2, range: 'from25to34'},
    {id: 3, range: 'from35to44'},
    {id: 4, range: 'from45to64'},
    {id: 5, range: 'from65'}
  ],
  defaultMinValue: 0,
  defaultMaxPercentValue: 1,
  defaultMaxValue: 100,
  discoverFilterLabelList: [
    {id: 0, name: 'countries'},
    {id: 1, name: 'genders'},
    {id: 2, name: 'platforms'},
    {id: 3, name: 'activity'},
    {id: 4, name: 'projects'},
    {id: 5, name: 'interest'},
    {id: 6, name: 'audience'}
  ]
};

export const AutoGroupFilterList = {
  singleValueColumn: 3,
  multipleValueColumn: 4,
  audienceOperatorList: [
    {id: 0.1, value: 10},
    {id: 0.2, value: 20},
    {id: 0.3, value: 30},
    {id: 0.4, value: 40},
    {id: 0.5, value: 50},
    {id: 0.6, value: 60},
    {id: 0.7, value: 70},
    {id: 0.8, value: 80},
    {id: 0.9, value: 90}
  ],
  averageOperatorList: [
    {id: 1, value: 'is at least'},
    {id: 2, value: 'is at most'},
  ],
  autoGroupValueList: [
    {id: 1000, name: '1,000'},
    {id: 2000, name: '2,000'},
    {id: 3000, name: '3,000'},
    {id: 5000, name: '5,000'},
    {id: 10000, name: '10,000'},
    {id: 25000, name: '25,000'},
    {id: 50000, name: '50,000'},
    {id: 100000, name: '100,000'},
    {id: 250000, name: '250,000'},
    {id: 500000, name: '500,000'},
    {id: 1000000, name: '1,000,000'},
  ],
  audienceAgeList: [
    {id: 1, value: '17-24', formatted: 'from17to24'},
    {id: 2, value: '25-34', formatted: 'from25to34'},
    {id: 3, value: '35-44', formatted: 'from35to44'},
    {id: 4, value: '45-54', formatted: 'from45to54'},
    {id: 5, value: '55+', formatted: 'from55to65'},
  ],
  platformValueList: [
    {id: 1, value: 'Instagram'},
    {id: 2, value: 'Youtube'},
    {id: 3, value: 'Blogs'},
    {id: 4, value: 'TikTok'},
  ],
  genders: {
    male: 'male',
    female: 'female',
    online_media: 'online_media'
  }
};

export enum InfluencerGroupStatus {
  PENDING = 'pending',
  COMPLETE = 'complete'
}

export enum InfluencerSortByEnum {
  REACH = 'Reach',
  ENGAGEMENT = 'Engagement',
  IMPACT = 'Impact',
  STATUS = 'Status'
}

export enum ApiStatusEnum {
  SUCCESS = 'success',
  FAILED = 'failed',
  SENDING = 'sending'
}



// WEBPACK FOOTER //
// ./src/app/app.constants.ts